function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".account-svg-non-color-part{fill:none;}.account-svg-color-part{fill:#686868;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "account-svg-non-color-part",
  d: "M0,0H24V24H0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "account-svg-color-part",
  d: "M10.25,13A1.25,1.25,0,1,1,9,11.75,1.25,1.25,0,0,1,10.25,13ZM15,11.75A1.25,1.25,0,1,0,16.25,13,1.25,1.25,0,0,0,15,11.75ZM22,12A10,10,0,1,1,12,2,10,10,0,0,1,22,12ZM10.66,4.12A7.99,7.99,0,0,0,17.5,8a8.346,8.346,0,0,0,1.34-.12A7.99,7.99,0,0,0,12,4,8.346,8.346,0,0,0,10.66,4.12ZM4.42,9.47A8.046,8.046,0,0,0,8.08,5.03,8.046,8.046,0,0,0,4.42,9.47ZM20,12a7.88,7.88,0,0,0-.33-2.24A10.306,10.306,0,0,1,17.5,10,10,10,0,0,1,9.74,6.31,10.016,10.016,0,0,1,4,11.86.653.653,0,0,1,4,12a8,8,0,0,0,16,0Z"
});

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.9d2fefd2.svg";
export { ForwardRef as ReactComponent };